import { useMemo, useState } from "react";
import { Search, Plus, Check } from "lucide-react";
import { brl } from "@/lib/format";
import { Chip, Input } from "@/components/kit";

import { norm } from "@/lib/search";

export default function ProductPicker({ products, categories, selectedIds, onAdd, showCost }) {
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("all");
  const list = useMemo(() => {
    const n = norm(q.trim());
    return products.filter((p) => p.active !== false && (cat === "all" || p.category_id === cat) && norm(p.name).includes(n));
  }, [products, q, cat]);
  return (
    <div className="card flex flex-col gap-3" data-testid="product-picker">
      <div className="h3">Adicionar produtos</div>
      <div className="relative">
        <Search size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 muted" />
        <Input className="pl-10" placeholder="Buscar produto cadastrado" value={q} onChange={(e) => setQ(e.target.value)} data-testid="picker-search-input" />
      </div>
      <div className="scroll-x">
        <Chip active={cat === "all"} onClick={() => setCat("all")} data-testid="picker-category-all">Todas</Chip>
        {categories.map((c) => <Chip key={c.id} active={cat === c.id} onClick={() => setCat(c.id)} data-testid={`picker-category-${c.id}`}>{c.name}</Chip>)}
      </div>
      <div className="divide max-h-[420px] overflow-y-auto -mx-1 px-1">
        {list.map((p) => {
          const added = selectedIds.has(p.id);
          return (
            <button key={p.id} type="button" className="w-full flex items-center gap-3 py-2.5 text-left disabled:opacity-60" disabled={added} onClick={() => onAdd(p)} data-testid={`picker-product-${p.id}`}>
              <div className="flex-1 min-w-0">
                <div className="label truncate">{p.name}</div>
                <div className="caption truncate">{p.category_name || "Sem categoria"} · {p.unit}{showCost ? ` · ${brl(p.unit_cost)}/${p.unit}` : ""}</div>
              </div>
              <span className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0" style={{ background: added ? "var(--brand)" : "var(--brand-soft)", color: added ? "#fff" : "var(--brand)" }}>
                {added ? <Check size={15} /> : <Plus size={15} />}
              </span>
            </button>
          );
        })}
        {!list.length && <p className="caption py-4">Nenhum produto encontrado.</p>}
      </div>
    </div>
  );
}
